
/* injects from baggage-loader */

'use strict';

import { Lvls, PlayerTypes } from './level-bar.const';

export default class levelBarController {
    constructor($log, $rootScope, $element) {
        'ngInject';
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$element = $element;

        this.lvls = Lvls;
        this.types = PlayerTypes;
    }

    renderCurrentLvl(){
        return this.lvls[this.$rootScope.$currentUser.level - 1];
    }

    renderCurrentType(){
        return this.types[this.$rootScope.$currentUser.type - 1];
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/level-bar/level-bar.controller.js